import React from "react";
import { Row, Col, Tag } from "antd";

export default function Status({ text }) {
  const color = (text) => {
    const colorObj = {
      published: { background: "#F3EFFD", color: "#835FEA" },
      draft: { background: "#FFF0DB", color: "#B37D36" },
      inactive: { background: "#f6f6f6", color: "darkgray" },
    };
    return colorObj[text] || { background: "#f6f6f6", color: "darkgray" };
  };
  return (
    <Row align="middle">
      <Col>
        <Tag
          color={color(text)?.background}
          style={{
            color: color(text)?.color,
            fontSize: 14,
            padding: "6px 18px",
            borderRadius: 32,
          }}
        >
          { text === "published"? "ACTIVE" : text?.toUpperCase()}
        </Tag>
      </Col>
    </Row>
  );
}
